import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./questionIntermediary.css";
import { Cookies } from "react-cookie";
import axios from "axios";
import $ from "jquery";

class QuestionIntermediary extends Component {
    state = {
        elemClassName: "text-outer",
        string: "",
        requestSent: false
    };

    componentDidMount() {
        let elemClassName = this.state.elemClassName;
        setTimeout(() => {
            elemClassName += " hidden";
            this.setState({ elemClassName });
        }, 3000);
        // let string = this.state.string;
        // console.log(this.state.string);
        // if (string == ""){
        //     axios.get('http://psychologytest.tsu.ge/backend/user/index/')
        //     .then(response => {
        //         string = response.data
        //         let startIndex = string.indexOf('<meta name="csrf-token" content="') + '<meta name="csrf-token" content="'.length;
        //         let lastIndex = null;

        //         for(let i=startIndex; i<string.length; i++){
        //             if(string[i]==='"'){
        //                 lastIndex = i;
        //                 break;
        //             }
        //         }
        //         string = string.substring(startIndex, lastIndex);
        //         this.setState({string});
        //     });
        // }
    }

    nextQestion = e => {
        if (e.keyCode === 32) {
            this.props.updateCounter();
        }
    };

    componentWillUnmount() {
        document
            .querySelector("body")
            .removeEventListener("keydown", this.nextQestion);
    }

    returnPostData(userAnswer, testName, date) {
        console.log(userAnswer);
        // let date = this.props.date;
        let postData = {};
        const token = this.props.token;
        localStorage.setItem("token", token);
        switch (testName) {
            case "Test1":
                {
                    let arrayFirstHalf = [];
                    let arraySecondHalf = [];
                    let postName = "signalPost";
                    let userAnswers = [];
                    for (let i = 0; i < userAnswer.length; i++) {
                        let answerData = {
                            sworpasux: userAnswer[i].isUserAnswerCorrect,
                            saertoraod: userAnswer[i].total,
                            ganlageba: userAnswer[i].arrangement,
                            ganlraod: userAnswer[i].quantity,
                            momxpasux: userAnswer[i].userAnswer,
                            pasxdro: userAnswer[i].answerTime,
                            upasuxatuara: userAnswer[i].answered,
                            testissworpas: userAnswer[i].correct,
                            signaluuid: userAnswer[i].uuidpas,
                            datauser: date,
                            id: userAnswer[i].id
                        };
                        userAnswers.push(answerData);
                    }
                    let halfwayThrough = Math.floor(userAnswers.length / 2);

                    arrayFirstHalf = userAnswers.slice(0, halfwayThrough);
                    arraySecondHalf = userAnswers.slice(
                        halfwayThrough,
                        userAnswers.length
                    );

                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": arrayFirstHalf
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: userAnswers
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": arraySecondHalf
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: userAnswers
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                }
                break;
            case "Test2":
                {
                    let arrayFirstHalf = [];
                    let arraySecondHalf = [];
                    let postName = "percPost";
                    let userAnswers = [];
                    for (let i = 0; i < userAnswer.length; i++) {
                        let answerData = {
                            persbig: userAnswer[i].persbig,
                            persbigpass: userAnswer[i].persbigpass,
                            momxpasux: userAnswer[i].userAnswer,
                            pasuxdro: userAnswer[i].answerTime,
                            upasuxtuara: userAnswer[i].answered,
                            sworipasux: userAnswer[i].isUserAnswerCorrect,
                            signaluuid: userAnswer[i].uuidpas,
                            similarityType: userAnswer[i].similarityType,
                            datauser: date,
                            id: userAnswer[i].id
                        };
                        userAnswers.push(answerData);
                    }
                    let halfwayThrough = Math.floor(userAnswers.length / 2);

                    arrayFirstHalf = userAnswers.slice(0, halfwayThrough);
                    arraySecondHalf = userAnswers.slice(
                        halfwayThrough,
                        userAnswers.length
                    );

                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arrayFirstHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arraySecondHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                }
                break;
            case "Test3":
                {
                    let arrayFirstHalf = [];
                    let arraySecondHalf = [];
                    let postName = "seleqcPost";
                    let userAnswers = [];
                    for (let i = 0; i < userAnswer.length; i++) {
                        let answerData = {
                            color: userAnswer[i].color,
                            text: userAnswer[i].text,
                            kebord: userAnswer[i].realAnswer,
                            momxpasux: userAnswer[i].userAnswer,
                            pasuxdro: userAnswer[i].answerTime,
                            upasuxtuara: userAnswer[i].answered,
                            sworipasux: userAnswer[i].isUserAnswerCorrect,
                            datauser: date,
                            signaluuid: userAnswer[i].uuidpas,
                            id: userAnswer[i].id
                        };
                        userAnswers.push(answerData);
                    }
                    let halfwayThrough = Math.floor(userAnswers.length / 2);

                    arrayFirstHalf = userAnswers.slice(0, halfwayThrough);
                    arraySecondHalf = userAnswers.slice(
                        halfwayThrough,
                        userAnswers.length
                    );

                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arrayFirstHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arraySecondHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                }
                break;
            case "Test4":
                {
                    let arrayFirstHalf = [];
                    let arraySecondHalf = [];
                    let postName = "seleqcPost";
                    let userAnswers = [];
                    for (let i = 0; i < userAnswer.length; i++) {
                        let answerData = {
                            variant: userAnswer[i].variant,
                            dashoreba: userAnswer[i].margin,
                            pirveliaso: userAnswer[i].firstLetter,
                            meoreaso: userAnswer[i].secondLetter,
                            momxpasux: userAnswer[i].userAnswer,
                            pasuxdro: userAnswer[i].answerTime,
                            upasuxtuara: userAnswer[i].answered,
                            sworipasux: userAnswer[i].isUserAnswerCorrect,
                            aimStimul: userAnswer[i].aimStimul,
                            distractor: userAnswer[i].distractor,
                            distractorType: userAnswer[i].distractorType,
                            datauser: date,
                            signaluuid: userAnswer[i].uuidpas,
                            id: userAnswer[i].id
                        };
                        userAnswers.push(answerData);
                    }
                    let halfwayThrough = Math.floor(userAnswers.length / 2);

                    arrayFirstHalf = userAnswers.slice(0, halfwayThrough);
                    arraySecondHalf = userAnswers.slice(
                        halfwayThrough,
                        userAnswers.length
                    );

                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arrayFirstHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arraySecondHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                }
                break;
            case "Test5":
                postData = null;
                break;
            case "Test6":
                {
                    console.log(userAnswers);
                    let arrayFirstHalf = [];
                    let arraySecondHalf = [];
                    let postName = "reaqPost";
                    let userAnswers = [];
                    for (let i = 0; i < userAnswer.length; i++) {
                        console.log(userAnswer[i]);
                        let answerData = {
                            pirveliaso: userAnswer[i].firstLetter,
                            pirvelgilak: userAnswer[i].firstKey,
                            meoreaso: userAnswer[i].secondLetter,
                            meoregilak: userAnswer[i].secondKey,
                            mesameaso: userAnswer[i].thirdLetter,
                            mesamegilak: userAnswer[i].thirdKey,
                            meotxeaso: userAnswer[i].fourthLetter,
                            meotxegilak: userAnswer[i].fourthKey,
                            momxpasux: userAnswer[i].userAnswer,
                            pasuxdro: userAnswer[i].answerTime,
                            upasuxtuara: userAnswer[i].answered,
                            sworipasux: userAnswer[i].isUserAnswerCorrect,
                            type: userAnswer[i].type,
                            stimul: userAnswer[i].stimul,
                            datauser: date,
                            signaluuid: userAnswer[i].uuidpas,
                            id: userAnswer[i].id
                        };
                        userAnswers.push(answerData);
                    }
                    let halfwayThrough = Math.floor(userAnswers.length / 2);

                    arrayFirstHalf = userAnswers.slice(0, halfwayThrough);
                    arraySecondHalf = userAnswers.slice(
                        halfwayThrough,
                        userAnswers.length
                    );

                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arrayFirstHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arraySecondHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                }
                break;
            case "Test7":
                {
                    let arrayFirstHalf = [];
                    let arraySecondHalf = [];
                    let postName = "mentPost";
                    let userAnswers = [];
                    for (let i = 0; i < userAnswer.length; i++) {
                        let answerData = {
                            id: userAnswer[i].id,
                            testaso: userAnswer[i].testLetter,
                            gradusi: userAnswer[i].degree,
                            revers: userAnswer[i].reverse,
                            momxpasux: userAnswer[i].userAnswer,
                            pasuxdro: userAnswer[i].answerTime,
                            upasuxtuara: userAnswer[i].answered,
                            sworipasux: userAnswer[i].isUserAnswerCorrect,
                            datauser: date,
                            signaluuid: userAnswer[i].uuidpas
                        };
                        userAnswers.push(answerData);
                        // console.log(userAnswers);
                    }
                    let halfwayThrough = Math.floor(userAnswers.length / 2);

                    arrayFirstHalf = userAnswers.slice(0, halfwayThrough);
                    arraySecondHalf = userAnswers.slice(
                        halfwayThrough,
                        userAnswers.length
                    );

                    // console.log(userAnswers);
                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arrayFirstHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arraySecondHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                }
                break;
            case "Test9":
                {
                    let arrayFirstHalf = [];
                    let arraySecondHalf = [];
                    let postName = "cnobisPost";
                    let userAnswers = [];
                    for (let i = 0; i < userAnswer.length; i++) {
                        let answerData = {
                            id: userAnswer[i].id,
                            realAnswer: userAnswer[i].realAnswer,
                            sequence: userAnswer[i].sequence,
                            symbol: userAnswer[i].symbol,
                            userAnswer: userAnswer[i].userAnswer,
                            answerTime: userAnswer[i].answerTime,
                            answered: userAnswer[i].answered,
                            isUserAnswerCorrect: userAnswer[i].isUserAnswerCorrect,
                            datauser: date,
                            signaluuid: userAnswer[i].uuidpas
                        };
                        userAnswers.push(answerData);
                        // console.log(userAnswers);
                    }
                    let halfwayThrough = Math.floor(userAnswers.length / 2);

                    arrayFirstHalf = userAnswers.slice(0, halfwayThrough);
                    arraySecondHalf = userAnswers.slice(
                        halfwayThrough,
                        userAnswers.length
                    );

                    // console.log(userAnswers);
                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arrayFirstHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                    $.ajax({
                        headers: {
                            "X-CSRF-TOKEN": token
                        },
                        url: `http://psychologytest.tsu.ge/backend/postadd/${postName}`,
                        dataType: "json",
                        type: "POST",
                        data: {
                            pas: arraySecondHalf
                        },
                        success: e => {
                            console.log(e);
                        },
                        error: e => {
                            console.log(e);
                        }
                    });
                }
                break;
        }
    }

    sendRequest = postData => {};

    render() {
        let { userAnswers } = { ...this.props };

        let wholeNumber = userAnswers.length;
        let percent = 0;
        let correctAnswers = 0;
        let cookie = new Cookies();

        for (let i = 0; i < userAnswers.length; i++) {
            if (userAnswers[i].isUserAnswerCorrect) {
                correctAnswers++;
            }
        }

        percent = (correctAnswers / wholeNumber) * 100;
        percent = percent.toFixed(2);

        let linkToReal = null;
        let button = (
            <button onClick={this.props.updateCounter} className="button">
                შემდეგი
            </button>
        );
        let testPercent = this.props.percent
            ? this.props.percent
            : parseInt(cookie.get("percent"));
        let sendRequest = null;
        localStorage.setItem("trialPercent", percent);
        console.log(localStorage.getItem("trialPercent"));
        // cookie.set("trialPercent", percent, { path: "/" });
        document
            .querySelector("body")
            .addEventListener("keydown", this.nextQestion);
        if (
            this.props.sortedQuestions.length === this.props.userAnswers.length
        ) {
            document
                .querySelector("body")
                .removeEventListener("keydown", this.nextQestion);
            button = null;
            if (
                parseFloat(percent) >= testPercent &&
                this.props.type === "demoquestions"
            ) {
                linkToReal = (
                    <NavLink
                        to={`${process.env.PUBLIC_URL}/${this.props.name}/modes/questions`}
                    >
                        <button className="button">
                            რეალურ ტესტზე გადასვლა
                        </button>
                    </NavLink>
                );
            }
            if (
                parseFloat(percent) < testPercent &&
                this.props.type === "demoquestions"
            ) {
                linkToReal = (
                    <NavLink
                        to={`${process.env.PUBLIC_URL}/${this.props.name}/modes`}
                    >
                        <button className="button">თავიდან დაწყება</button>
                    </NavLink>
                );
            }
            if (this.props.type === "questions") {
                button = (
                    <NavLink to={`${process.env.PUBLIC_URL}/result`}>
                        <button
                            className="button"
                            onClick={() => {
                                this.props.updateResultsForChart(
                                    userAnswers,
                                    this.props.name
                                );
                            }}
                        >
                            შედეგების ნახვა
                        </button>
                    </NavLink>
                );
                // console.log(this.props.requestSend);
                if (!this.props.requestSend) {
                    let date = this.props.date;
                    this.returnPostData(
                        this.props.userAnswers,
                        this.props.name,
                        date
                    );
                    this.props.sentRequest();
                    localStorage.setItem("testDate", date);
                    // for(let i =0; i<this.props.userAnswers.length; i++){
                    //     this.returnPostData(this.props.userAnswers[i], this.props.name,date);
                    //     // this.sendRequest(postData);
                    //     this.props.sentRequest();
                    // }
                }
            }
        }

        const answer = userAnswers[userAnswers.length - 1].isUserAnswerCorrect;
        const answered = userAnswers[userAnswers.length - 1].answered;

        let answerTime = userAnswers[userAnswers.length - 1].answerTime;
        // answerTime = (answerTime / 1000).toFixed(2);
        let className = "inner-text";
        let answeredClassName = "";
        userAnswers[userAnswers.length - 1].showTimeText
            ? (answeredClassName = "inner-text")
            : (answeredClassName = "inner-text hidden");
        answer ? (className += " green") : (className += " red");

        const textToShow = answered ? (
            <p className={className}>
                თქვენი პასუხი არის {answer ? "სწორი" : "მცდარი"}
            </p>
        ) : (
            <p className={className}>თქვენ ვერ მოასწარით პასუხის დაფიქსირება</p>
        );

        let elemClassName = this.state.elemClassName;
        return (
            <React.Fragment>
                <div className="plus-for-inter">+</div>

                <div className="questionIntermediary">
                    <div className={elemClassName}>
                        {textToShow}
                        <p className="inner-text">სწორია {percent}%</p>
                        <p className={answeredClassName}>
                            პასუხის დრო {answerTime} მწმ
                        </p>
                    </div>
                    {button}
                    {linkToReal}
                    {sendRequest}
                </div>
            </React.Fragment>
        );
    }
}

export default QuestionIntermediary;
